import { render, staticRenderFns } from "./developing.vue?vue&type=template&id=16f54b93&"
import script from "./developing.vue?vue&type=script&lang=js&"
export * from "./developing.vue?vue&type=script&lang=js&"
import style0 from "./developing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports